import { css } from '@emotion/css';
import { setDefault } from '../../styles/theme';
import '../../styles/global';
import { cache } from '../utils';
setDefault(function () {
  makeStyles == null || makeStyles.clearCache();
});
export var makeStyles = cache(function makeStyles(k, maxLines) {
  return /*#__PURE__*/css("width:100%;&.", k, "-multiline{.k-ellipsis-wrapper{white-space:normal;display:-webkit-box;-webkit-line-clamp:", maxLines, ";-webkit-box-orient:vertical;}}");
});